import moment from 'moment'
moment.locale('pt-br')

const methods = {
  format: (date) => {
    if (date !== null) {
      return moment(date).format('L') // DD/MM/AAAA
    } else {
      return '-'
    }
  },
  formatMonthYear: (date) => {
    if (date !== null) {
      return moment(date).format('MM/YYYY') // MM/AAAA
    } else {
      return '-'
    }
  },
  formatFirstDayMonth: (date) => {
    if (date !== null) {
      return moment(date).startOf('month').format('L') // 01/MM/AAAA
    } else {
      return '-'
    }
  },
  formatLastDayMonth: (date) => {
    if (date !== null) {
      return moment(date).endOf('month').format('L') // 28/MM/AAAA ou 29/MM/AAAA ou 30/MM/AAAA ou 31/MM/AAAA (dependendo do mês)
    } else {
      return '-'
    }
  },
  formatDateHour: (date) => {
    return moment(date).format('DD/MM/YYYY HH:mm:ss') // DD/MM/AAAA
  },
  formatStyle: (date, style) => {
    return moment(date).format(style)
  },
  APIFormat: (date) => {
    return moment(date).format('YYYY-MM-DD')
  },
  daysDiff: (startDate, endDate) => {
    if (endDate) {
      startDate = moment(startDate)
      endDate = moment(endDate)
      return Math.abs(startDate.diff(endDate, 'days', true))
    } else {
      startDate = moment(startDate)
      endDate = moment(Date.now())
      return Math.abs(startDate.diff(endDate, 'days', true))
    }
  },
  daysDiffInteger: (startDate, endDate) => {
    if (endDate) {
      startDate = moment(startDate)
      endDate = moment(endDate)
      return Math.abs(startDate.diff(endDate, 'days'))
    } else {
      startDate = moment(startDate)
      endDate = moment(Date.now())
      return Math.abs(startDate.diff(endDate, 'days'))
    }
  },
  daysDiffSigned: (startDate, endDate) => {
    if (endDate) {
      startDate = moment(startDate)
      endDate = moment(endDate)
      return startDate.diff(endDate, 'days', true)
    } else {
      startDate = moment(startDate)
      endDate = moment(Date.now())
      return startDate.diff(endDate, 'days', true)
    }
  },
  subtract: (date, quantity, type) => {
    return moment(date).subtract(quantity, type).format()
  },
  add: (date, quantity, type) => {
    return moment(date).add(quantity, type).format()
  },
  now: () => {
    return moment(new Date()).format()
  }
}

export default methods



// WEBPACK FOOTER //
// ./src/utils/dates.js